import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton, SkeletonLine, SkeletonRegion } from "@/components/ui/skeleton";

/**
 * Drawn before the session says which of the three doors this is. A card, because two of them
 * are one and the third is wider than any skeleton here could promise.
 */
export function PageSkeleton() {
  return (
    <SkeletonRegion>
      <Card>
        <CardHeader>
          {/* The title's own line height - `CardTitle` is text-lg with leading-none. */}
          <Skeleton className="h-[18px] w-52" />
          <SkeletonLine className="w-72" />
        </CardHeader>
        <CardContent className="flex flex-wrap gap-2">
          <Skeleton className="h-9 w-48" />
          <Skeleton className="h-9 w-44" />
        </CardContent>
      </Card>
    </SkeletonRegion>
  );
}
